import {Typography} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {FooterDesktop, FooterLink} from '@logistics-frontend/order-layout-blocks'
import React, {memo} from 'react'

import NavLinks from 'src/shared/components/footer-menu/NavLinks'
import ArrowCircle from 'src/shared/components/icons/ArrowCircle'
import ArrowSquare from 'src/shared/components/icons/ArrowSquare'
import ArrowSquareShort from 'src/shared/components/icons/ArrowSquareShort'
import Car from 'src/shared/components/icons/Car'
import Dashboard from 'src/shared/components/icons/Dashboard'
import Door from 'src/shared/components/icons/Door'
import YaLogo from 'src/shared/components/icons/YaLogo'

import {useAppConfigContext} from '../../shared/contexts/AppConfigContext'
import appGallerySrc from './assets/app-gallery-btn.svg'
import appStoreSrc from './assets/app-store-btn.svg'
import boxSrc from './assets/box.gif'
import expressSrc from './assets/express.gif'
import googlePlaySrc from './assets/google-play-btn.svg'
import qrSrc from './assets/qr.gif'
import thumbsUpSrc from './assets/thumb-up-w.gif'
import * as classes from './classes'
import {makeSeoHeading} from './utils/makeSeoHeading'

type Props = {}

export const Footer = memo(function Footer(_: Props): React.ReactElement<Props> {
  const i18n = useI18n()
  const {initialProps} = useAppConfigContext()

  return (
    <FooterDesktop
      footerApp={{
        qr: <img alt="qr" className={classes.qr} height={160} loading="lazy" src={qrSrc} width={160} />,
        stores: (
          <>
            <a href="https://8jxm.adj.st/route?tariffClass=express&ref=dostavka_web_badge&adj_t=ivdp40&adj_campaign=ALL-ALL-ALL&adj_adgroup=dostavka_web_badge&adj_deeplink=yandextaxi%3A%2F%2Froute%3FtariffClass%3Dexpress%26ref%3Ddostavka_web_badge">
              <img alt="" height={46} loading="lazy" src={appStoreSrc} width={185} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=ru.yandex.taxi">
              <img alt="" height={46} loading="lazy" src={googlePlaySrc} width={185} />
            </a>
            <a href="https://appgallery.huawei.com/app/C101411413">
              <img alt="" height={46} loading="lazy" src={appGallerySrc} width={185} />
            </a>
          </>
        ),
      }}
      footerIcons={
        <>
          <YaLogo className={classes.icon} />
          <Car className={classes.icon} />
          <ArrowCircle className={classes.icon} />
          <img alt="" className={classes.icon} height={144} loading="lazy" src={boxSrc} width={200} />
          <ArrowSquare className={classes.icon} />
          <Dashboard className={classes.icon} />
          <img alt="" className={classes.icon} height={85} loading="lazy" src={expressSrc} width={85} />
          <ArrowSquareShort className={classes.icon} />
          <Door className={classes.icon} />
          <img alt="" className={classes.icon} height={85} loading="lazy" src={thumbsUpSrc} width={85} />
        </>
      }
      footerLogo={{phrase1: 'Доставка в приложении', phrase2: 'Наведите камеру на QR-код, чтобы скачать'}}
      legal={
        <>
          Яндекс.Доставка — услуги для юридических лиц. Яндекс Go — информационный сервис.
          <br />
          Транспортные и иные услуги оказываются партнерами сервиса.
          <br />
          Подробнее о тарифах Курьер, Доставка и Грузовой
        </>
      }
      legalLinks={
        <>
          <FooterLink href="/tariffs/">Тарифы</FooterLink>
          <FooterLink href="https://taxi.yandex.ru/action/logistics/" rel="noreferrer" target="_blank">
            Партнеры
          </FooterLink>
          <FooterLink href="https://yandex.ru/legal/delivery_tou/" rel="noreferrer" target="_blank">
            Пользовательское соглашение
          </FooterLink>
          <FooterLink href="https://yandex.ru/legal/recommendations/#index__dostavka" rel="noreferrer" target="_blank">
            Как работают рекомендации
          </FooterLink>
        </>
      }
      navLinkList={<NavLinks />}
      seoHeading={
        <Typography className={classes.seoHeading} color="invert" variant="header">
          {i18n(makeSeoHeading(initialProps.zoneName, initialProps.tariff), 'Рассчитайте стоимость доставки по городу')}
        </Typography>
      }
      storeDisclaimers={
        <>
          Google Play и логотип Google Play являются товарными знаками корпорации Google LLC.
          <br />
          App Store является знаком обслуживания компании Apple Inc.
          <br />
          App Gallery, HUAWEI и логотип HUAWEI являются товарными знаками компании Huawei Technologies Co., Ltd.
        </>
      }
    />
  )
})
